function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M144 311v-99c0-7 5-12 12-12h71c7 0 12 5 12 12v99h75V119L191 27 68 119v192h76zM314 89V57c0-6 5-12 12-12 6 0 12 6 12 12l-1 50 41 30c5 4 6 11 2 16-4 6-11 7-17 3l-26-20v186c1 7-4 13-12 13H57c-7 0-12-5-12-12V136l-26 20c-5 4-13 3-17-3-4-5-2-12 3-16L184 2c4-3 10-3 14 0l116 87zm-99 222v-88h-48v88h48z",
  fillRule: "nonzero"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 382 335",
    fillRule: "evenodd",
    clipRule: "evenodd",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality"
  }, props), _ref);
}

export default SvgHome;